import { AmountLineItem, Badge } from 'corso-admin-ui';
import { Key } from 'react';
import { useCurrency } from '~/hooks/useCurrency';

export type Refund = {
  id: Key;
  amount: number;
  wasResolvedExternally: boolean;
};

export function RefundLineItem({
  refund: { amount, wasResolvedExternally },
}: {
  refund: Refund;
}) {
  const { currencyCode } = useCurrency();
  return (
    <AmountLineItem
      size="sm"
      media={{ icon: 'payment' }}
      title="Refund"
      currencyCode={currencyCode}
      amount={amount}
    >
      <AmountLineItem.Detail>
        <Badge>
          {wasResolvedExternally
            ? 'Resolved Outside Corso'
            : 'Original Payment Method'}
        </Badge>
      </AmountLineItem.Detail>
    </AmountLineItem>
  );
}
